import { useState } from 'react';

export interface SecretRevealProps {
  title: string;
  values: Record<string, string>;
  onClose: () => void;
}

// One-shot reveal modal for tokens / HMAC secrets returned from create-time
// admin endpoints. Values are never retrievable again — UX must make that clear.
export function SecretReveal({ title, values, onClose }: SecretRevealProps) {
  const [copied, setCopied] = useState<string | null>(null);

  function copy(key: string, value: string) {
    navigator.clipboard.writeText(value).then(() => {
      setCopied(key);
      setTimeout(() => setCopied(null), 2000);
    });
  }

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 100,
      }}
    >
      <div
        style={{
          background: 'white',
          borderRadius: 8,
          padding: 24,
          maxWidth: 560,
          width: '90%',
          boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
        }}
      >
        <h2 style={{ margin: 0, fontSize: 18 }}>{title}</h2>
        <p style={{ color: '#dc2626', fontSize: 13, marginTop: 8 }}>
          Copy now. These values cannot be retrieved later.
        </p>
        {Object.entries(values).map(([k, v]) => (
          <div key={k} style={{ marginTop: 12 }}>
            <div style={{ fontSize: 11, color: '#6b7280', textTransform: 'uppercase', marginBottom: 4 }}>{k}</div>
            <div style={{ display: 'flex', gap: 8 }}>
              <input
                readOnly
                value={v}
                onFocus={(e) => e.currentTarget.select()}
                style={{
                  flex: 1,
                  fontFamily: 'monospace',
                  fontSize: 12,
                  padding: '6px 8px',
                  border: '1px solid #d1d5db',
                  borderRadius: 6,
                }}
              />
              <button
                onClick={() => copy(k, v)}
                style={{
                  padding: '6px 12px',
                  background: '#2563eb',
                  color: 'white',
                  border: 'none',
                  borderRadius: 6,
                  cursor: 'pointer',
                  fontSize: 12,
                }}
              >
                {copied === k ? '✓' : 'Copy'}
              </button>
            </div>
          </div>
        ))}
        <div style={{ marginTop: 20, textAlign: 'right' }}>
          <button
            onClick={onClose}
            style={{
              padding: '8px 16px',
              background: '#374151',
              color: 'white',
              border: 'none',
              borderRadius: 6,
              cursor: 'pointer',
              fontSize: 14,
            }}
          >
            Done
          </button>
        </div>
      </div>
    </div>
  );
}
